import * as React from "react";
import { forwardRef } from "react";
const SvgIconVoicemail = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.267 9a3.267 3.267 0 1 0 0 6.533h7.467a3.286 3.286 0 1 0-2.276-.933H6.542A3.259 3.259 0 0 0 4.267 9m0 .933a2.333 2.333 0 1 1-2.333 2.333 2.326 2.326 0 0 1 2.333-2.333m7.467 0A2.333 2.333 0 1 1 9.4 12.267a2.326 2.326 0 0 1 2.333-2.334z", "data-name": "icon/voicemail", transform: "translate(-1 -5.25)", fill: "#2d98da" }));
const ForwardRef = forwardRef(SvgIconVoicemail);
export { ForwardRef as ReactComponent };
